import { GraphQLClient, type RequestMiddleware } from 'graphql-request'

import { env } from '@/env'

import { getAccessToken } from './graphqlAuth'

export const GRAPHQL_ENDPOINT = env.VITE_GRAPHQL_URL

export const authRequestMiddleware: RequestMiddleware = (request) => {
  const token = getAccessToken()
  if (token) {
    const headers = new Headers(request.headers)
    headers.set('Authorization', `Bearer ${token}`)
    return {
      ...request,
      headers,
    }
  }
  return request
}

export const graphqlClient = new GraphQLClient(GRAPHQL_ENDPOINT, {
  requestMiddleware: authRequestMiddleware,
})
